const Page404 = () => {
  return (
    <div>
      <p>404 Page</p>
    </div>
  );
};

export default Page404;
